export default __webpack_public_path__ + "static/media/Ishaan.bfb21b2b.jpg";